import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SoundProvider } from './sound';
import MedalToaster from './components/MedalToaster';
import GnomeVisit from './components/GnomeVisit';
import BackroomsDoor from './components/BackroomsDoor';
import DialogHost from './components/DialogHost';
import MedalPopup from './components/MedalPopup';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <SoundProvider>
        <App />
        <MedalToaster />
        <GnomeVisit />
        <BackroomsDoor />
        <MedalPopup />
        <DialogHost />
    </SoundProvider>
);

